import { Typography } from '@/shared/components/ui/typography'
import { useEffect } from 'react'

const NotFound = () => {
  useEffect(() => {
    document.title = 'Page Not Found | Mydra'
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <Typography variant="h1" className="mb-4">
          404
        </Typography>
        <Typography
          variant="body1"
          className="mb-4 text-xl font-normal text-gray-600"
        >
          Oops! Page not found
        </Typography>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Return to Home
        </a>
      </div>
    </div>
  )
}

export default NotFound
